export const SERVER_URL = 'https://api-app.snapdeliveredteam.com/'
export const WS_SERVER_URL = 'wss://api-app.snapdeliveredteam.com/'
export const CLOUDINARY_UPLOAD_URL =
  'https://api.cloudinary.com/v1_1/diabgoazd/image/upload'
export const CLOUDINARY_CATEGORY = 'i2kult03'
export const CLOUDINARY_FOOD = 'lckdazok'
export const CLOUDINARY_PROFILE = 'tnuqsbjz'
